export default "__VITE_ASSET__BLgy$yy___"